////declare global {
////	interface Window {
////		clipboardData: any
////	}
////}
(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("bulkAddAccounts", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/accounts/add/bulkAddAccountsView.html",
            controller: ["authService", "frameworkService", "accountsResource", "tierPriceResource", "messageService", "$translate", "$scope", "_", BulkAddAccountsCtrl],
            controllerAs: "vm"
        };
        function BulkAddAccountsCtrl(authService, frameworkService, accountsResource, tierPriceResource, messageService, $translate, $scope, _) {
            var vm = this;
            var features = frameworkService.data.tenantFeatures;
            vm.sending = false;
            vm.updateSampleFormat = updateSampleFormat;
            vm.isOrgAdmin = authService.isOrgAdmin();
            vm.isGroupAdmin = authService.isGroupAdmin();
            vm.isSuperOrSiteAdmin = authService.isSuperOrSiteAdmin();
            vm.organizationHierarchyType = frameworkService.data.tenant.tenantFeaturesOrganizationHierarchyType;
            vm.showOrganization = features.organization && (vm.isSuperOrSiteAdmin || (vm.isOrgAdmin && vm.organizationHierarchyType === 2));
            vm.organizationRequired = frameworkService.data.tenant.tenantFeaturesOrganizationIsRequired;
            vm.showGroup = frameworkService.data.tenant.hasGroups && vm.isSuperOrSiteAdmin || vm.isGroupAdmin;
            vm.selfRegistrationEnabled = features.selfRegistration;
            vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
            vm.showPricingTier = false;
            tierPriceResource.getEnabled(function (data) {
                vm.showPricingTier = vm.isSuperOrSiteAdmin && features.storefront && data.length > 0;
            });
            vm.availableLanguages = _.map(_.pluck(vm.enabledLocalizations, "name"), function (name) {
                return $translate.instant("common.localization." + name.replace(/ /g, ""));
            }).join(", ");
            vm.preferredLanguageLabel = $translate.instant("account.create.preferredLanguage") + " (" + vm.availableLanguages + ")";
            vm.firstName = { name: "account.create.firstNameLabel", colName: "FirstName", checked: true };
            vm.lastName = { name: "account.create.lastNameLabel", colName: "LastName", checked: true };
            vm.username = { name: "account.create.userNameLabel", colName: "Username", checked: true };
            vm.email = { name: "account.create.emailLabel", colName: "Email", checked: vm.selfRegistrationEnabled };
            vm.preferredLanguage = { name: "account.create.preferredLanguage", colName: "PreferredLanguage", checked: false };
            vm.group = { name: "account.bulkAdd.form.groupLabel", colName: "Group", checked: vm.showGroup };
            vm.organization = { name: "account.profile.organization", colName: "Organization", checked: vm.showOrganization };
            vm.pricingTier = { name: "account.bulkAdd.form.tierPriceLabel", colName: "PricingTier", checked: vm.showPricingTier };
            vm.updateSampleFormat();
            vm.failedEntries = [];
            vm.content = {};
            ///////////////////////////////////////////////////////////////////////
            function updateSampleFormat() {
                vm.selectedFields = _.where([vm.firstName, vm.lastName, vm.username, vm.email, vm.preferredLanguage, vm.group, vm.organization, vm.pricingTier], { checked: true });
                vm.sample = _.map(_.pluck(vm.selectedFields, "name"), function (item) {
                    return $translate.instant(item);
                }).join();
            }
            vm.createAccounts = function (isValid) {
                if (isValid) {
                    vm.sending = true;
                    vm.failedEntries = [];
                    var model = {
                        data: vm.content.data,
                        columns: _.map(vm.selectedFields, function (item) {
                            return { name: item.colName, index: vm.selectedFields.indexOf(item) };
                        })
                    };
                    accountsResource.bulkAdd(model, function (result) {
                        if (result) {
                            if (result.failureCount === 0 && result.alreadyCreatedAccountsCount === 0) {
                                messageService.success("account.bulkAdd.successNotification", { count: result.successCount });
                                vm.content.data = "";
                                vm.showErrors = false;
                                vm.failureCount = 0;
                                vm.alreadyCreatedAccountsCount = 0;
                            }
                            else {
                                vm.failureCount = result.failureCount;
                                vm.alreadyCreatedAccountsCount = result.alreadyCreatedAccountsCount;
                                vm.failedEntries = result.details;
                                vm.content.data = _.pluck(result.details, "data").join("\n");
                                vm.successCount = result.successCount;
                                messageService.error("account.bulkAdd.failureNotification");
                            }
                            $scope.$emit("checkSubscription");
                        }
                        else {
                            messageService.error("common.genericError");
                        }
                        vm.sending = false;
                    }, function (error) {
                        messageService.error(error);
                        vm.sending = false;
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.paste = function (event) {
                if (event) {
                    event.preventDefault();
                    var rows;
                    if (event.originalEvent.clipboardData)
                        rows = event.originalEvent.clipboardData.getData("text/plain").split("\n");
                    else //IE
                        rows = window.clipboardData.getData("Text").split("\n");
                    //split each row into columns then join them with a ','
                    //Append the new clipboard data to the existing value of the textarea
                    var newData = _.map(rows, function (row) {
                        return row.split("\t").join(",");
                    }).join("\n");
                    if (vm.content.data)
                        vm.content.data += newData;
                    else
                        vm.content.data = newData;
                }
            };
        }
    });
}());
